import React from "react";

interface LoadingIndicatorProps {
  /**
   * The text to display next to the spinner.
   * @default "Loading..."
   */
  text?: string;
  /**
   * Additional container classnames for customization.
   */
  className?: string;
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({
  text = "Loading...",
  className = "",
}) => {
  return (
    <div className={`mt-3 flex items-center ${className}`}>
      <div className="animate-spin h-4 w-4 border-2 border-blue-500 border-t-transparent rounded-full mr-2" />
      <span className="text-sm text-gray-600">{text}</span>
    </div>
  );
};

export default LoadingIndicator;
